<script lang="ts">
  import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from "sveltestrap"
  import TradeRounds from "./TradeRounds.svelte"
  import BidNFT from "./BidNFT.svelte"
  import Trade from "./Trade.svelte"

  const TABS = {
    TRADE_ROUNDS: { name: "Trade Rounds", component: TradeRounds },
    BID_METANFT: { name: "Bid metaNFT", component: BidNFT },
    BID_NFT: { name: "Bid NFT", component: BidNFT },
  }

  let currentTab = TABS.TRADE_ROUNDS
</script>

<div class="pil-nav-tabs-card">
  <Row>
    <Col>
      <Nav tabs class="pil-nav-tabs">
        {#each Object.values(TABS) as tab}
          <Col>
            <NavItem>
              <NavLink
                class="pil-nav-link"
                href="#"
                on:click={() => (currentTab = tab)}
                active={currentTab !== tab}
              >
                <div class={currentTab === tab ? ' pil-nav-active' : ''}>
                  {tab.name}
                </div>
              </NavLink>
            </NavItem>
          </Col>
        {/each}
      </Nav>
    </Col>
  </Row>
  {#if currentTab === TABS.TRADE_ROUNDS}
    <TradeRounds/>
  {:else if currentTab === TABS.BID_METANFT}
    <BidNFT isNft={false}/>
  {:else}
    <BidNFT isNft={true}/>
  {/if}
</div>




<!--<TabContent>-->
<!--  {#each Object.values(TABS) as tab}-->
<!--    <TabPane-->
<!--      class="trade"-->
<!--      tabId={tab.name}-->
<!--      tab="{tab.name}"-->
<!--      href="#"-->
<!--      on:click={() => (currentTab = tab.name)}-->
<!--      active={currentTab === tab}-->
<!--    >-->
<!--      <svelte:component this={currentTab.component} />-->
<!--    </TabPane>-->
<!--  {/each}-->
<!--</TabContent>-->
